<template>
  <v-card @click="showExpensesPaid()" color="success" :disabled="loading">
    <v-progress-linear v-show="loading" color="white" indeterminate></v-progress-linear>
    <v-card-text>
      <v-row>
        <v-col cols="1" class="text-title-card">
          <v-icon x-large dark> mdi-currency-usd </v-icon>
        </v-col>
        <v-col class="text-right text-title-card">
            <v-row no-gutters>
                <v-col>
                    <span v-if="error">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon  color="yellow" v-bind="attrs" v-on="on"> mdi-alert </v-icon>
                      </template>
                      <span>{{errorMessage}}</span>
                    </v-tooltip>
                    </span>
                    AVANÇO FINANCEIRO
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    {{ formatMoneyPrecision1(custoRealizadoPorcentagem) }} %
                </v-col>
            </v-row>

        </v-col>
      </v-row>

      <v-row no-gutters class="text-data-card mt-4">
        <v-col>CUSTO REALIZADO</v-col>
        <v-col class="text-right">R$ {{formatMoney(custoRealizado) }} </v-col>
      </v-row>
      <v-row no-gutters class="text-data-card ">
        <v-col >CUSTO TOTAL</v-col>
        <v-col class="text-right"> R$ {{ formatMoney(custoTotal) }} </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
        errorMessage: '',
        error: false,
      loading: false,
      custoTotal: 0,
      custoRealizado: 0,
      custoRealizadoPorcentagem:0,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("Dashboard", ["getAvancoFinaceiro"]),
    getData() {
      this.loading = true;
      this.getAvancoFinaceiro()
        .then((response) => {
            this.custoTotal = response.data.custo_total
            this.custoRealizado = response.data.sum_expenses_paid
            this.custoRealizadoPorcentagem = response.data.cost_realized_percentage
        }).catch(error => {
          if(error.response.status === 423){
            this.errorMessage = error.response.data.message;
            this.error = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showExpensesPaid(){
        this.$router.push('/system/budget/expenses_paid');
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatMoneyPrecision1(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
  },
};
</script>

<style scoped>
.text-title-card {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.text-data-card {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
